module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_opinions_donald-trump-is-a-unique-threat-to-american-democracy_2016_07_22_a6d823cc-4f4f-11e6-aa14-e0c1087f7583_story.html_plot.c3aec086.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_opinions_donald-trump-is-a-unique-threat-to-american-democracy_2016_07_22_a6d823cc-4f4f-11e6-aa14-e0c1087f7583_story.html_plot.png
// module id = 437
// module chunks = 0